import { CardHeader } from '../card/card-header.component';

// For now PanelHeader is a CardHeader. Override this file to change that.

export const PanelHeader = CardHeader;

export default PanelHeader;
